import { Box, Container, Typography } from "@mui/material";

const SectionHeader = ({
  eyebrow,
  title,
  subtitle,
  description,
  align = "center",
  maxWidth = "md"
}) => {
  const textAlign = align === "center" ? "center" : "left";

  return (
    <Container maxWidth={maxWidth} sx={{ textAlign, mb: { xs: 4, md: 6 } }}>
      {eyebrow && (
        <Box mb={1}>
          <Typography variant="overline" color="primary">
            {eyebrow}
          </Typography>
        </Box>
      )}
      {title && (
        <Box mb={subtitle || description ? 1 : 0}>
          <Typography variant="h2" color="textPrimary">
            {title}
          </Typography>
        </Box>
      )}
      {subtitle && (
        <Box mb={description ? 2 : 0}>
          <Typography variant="h5" color="textSecondary">
            {subtitle}
          </Typography>
        </Box>
      )}
      {description && (
        <Typography variant="body1" color="textSecondary">
          {description}
        </Typography>
      )}
    </Container>
  );
};
export default SectionHeader;
